import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { AppShell } from "./components/AppShell";
import LoginPage from "./pages/LoginPage";
import AyarlarPage from "./pages/AyarlarPage";
import ErisimYokPage from "./pages/ErisimYokPage";
import CiroPage from "./pages/CiroPage";
import MaliyetPage from "./pages/MaliyetPage";
import GiderPage from "./pages/GiderPage";
import DashboardPage from "./pages/DashboardPage";
import PersonelPage from "./pages/PersonelPage";
import NakitAkisPage from "./pages/NakitAkisPage";
import FinansalAnalizPage from "./pages/FinansalAnalizPage";
import { Loader2 } from "lucide-react";
import "./App.css";

const FullScreenLoader = () => (
  <div className="flex min-h-screen items-center justify-center bg-background">
    <Loader2 className="h-8 w-8 animate-spin text-[hsl(var(--primary))]" />
  </div>
);

const ProtectedLayout = () => {
  const { user, loading } = useAuth();
  if (loading) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell />;
};

const RoleGate = ({ roles, children }) => {
  const { user } = useAuth();
  if (!roles.includes(user.role)) return <ErisimYokPage />;
  return children;
};

const LoginRoute = () => {
  const { user, loading } = useAuth();
  if (loading) return <FullScreenLoader />;
  if (user) return <Navigate to="/" replace />;
  return <LoginPage />;
};

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route element={<ProtectedLayout />}>
            <Route path="/" element={<DashboardPage />} />
            <Route
              path="/ciro"
              element={
                <RoleGate roles={["yonetici", "operasyon"]}>
                  <CiroPage />
                </RoleGate>
              }
            />
            <Route
              path="/gider"
              element={
                <RoleGate roles={["yonetici", "operasyon"]}>
                  <GiderPage />
                </RoleGate>
              }
            />
            <Route
              path="/maliyet"
              element={
                <RoleGate roles={["yonetici", "operasyon"]}>
                  <MaliyetPage />
                </RoleGate>
              }
            />
            <Route
              path="/nakit-akis"
              element={
                <RoleGate roles={["yonetici", "goruntuleyici"]}>
                  <NakitAkisPage />
                </RoleGate>
              }
            />
            <Route
              path="/finansal-analiz"
              element={
                <RoleGate roles={["yonetici", "goruntuleyici"]}>
                  <FinansalAnalizPage />
                </RoleGate>
              }
            />
            <Route
              path="/personel"
              element={
                <RoleGate roles={["yonetici"]}>
                  <PersonelPage />
                </RoleGate>
              }
            />
            <Route path="/ayarlar" element={<AyarlarPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
